// import Vue from 'vue'
// import Router from 'vue-router'

// Vue.use(Router)
/* eslint-disable */
import Layout from '@/layout/layout.vue'
import Layout404 from '@/layout/layout404.vue'
import store from '@/store/index.js'
/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    name: 'name'               the name show in sidebar and breadcrumb (recommend set)
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [

  {
    name:"登录",
    path: '/',
    component: () => import('@/views/login/login.vue'),
  },

  {
    path: '/account',
    component:Layout,
    redirect: '/account/index',
    children:[
      {
        name:"个人信息",
        path: '/account/index',
        component: () => import('@/views/account/index.vue'),
       
      }
    ]
  },

   // 平台-财务管理
   {
    path: '/admin/finance',
    component:Layout,
    redirect:'/admin/finance/search',
    children:[
      {
        name:"交易查询",
        path: '/admin/finance/search',
        component: () => import('@/views/platform/finance/search.vue'),
      },
      {
        name:"物流结算",
        path: '/admin/finance/logistics',
        component: () => import('@/views/platform/finance/logistics.vue'),
      },
      {
        name:"退款列表",
        path: '/admin/finance/refund',
        component: () => import('@/views/platform/finance/refund.vue'),
      },
      {
        name:"提现管理",
        path: '/admin/finance/withdrawal',
        component: () => import('@/views/platform/finance/withdrawal.vue'),
      },
      {
        name:"财务报表",
        path: '/admin/finance/report',
        component: () => import('@/views/platform/finance/report.vue'),
      },
      {
        name:"销售报表",
        path: '/admin/finance/refund-report',
        component: () => import('@/views/platform/finance/refund-report.vue'),
      },
      {
        name:"退款报表",
        path: '/admin/finance/refund-reimburse',
        component: () => import('@/views/platform/finance/reimburse.vue'),
      },
      {
        name:"商家结算",
        path: '/admin/finance/budget',
        component: () => import('@/views/platform/finance/budget.vue'),
      },
      {
        name:"Monthly Bookkeeping",
        path: '/admin/finance/monthly-bookkeep',
        component: () => import('@/views/platform/finance/monthly-bookkeep.vue'),
      },
    ]
  },
  // 平台-后台管理
  {
    path: '/admin/admin',
    component:Layout,
    redirect:'/admin/admin/auth',
    children:[
      {
        name:"权限管理",
        path: '/admin/admin/auth',
        component: () => import('@/views/platform/auth/list.vue'),
      },
      {
        name:"角色管理",
        path: '/admin/admin/role',
        component: () => import('@/views/platform/role/list.vue'),
      },
      {
        name:"栏目管理",
        path: '/admin/admin/meau',
        component: () => import('@/views/platform/meau/list.vue'),
      },
      {
        name:"平台管理员",
        path: '/admin/admin/manage',
        component: () => import('@/views/platform/manage/list.vue'),
      },
      {
        name:"黑名单管理",
        path: '/admin/admin/blacklist',
        component: () => import('@/views/platform/blacklist/index.vue'),
      }
    ]
  },
  // 平台-平台管理
  {
    path: '/admin/platform',
    component:Layout,
    redirect:'/admin/platform/postage',
    children:[
      {
        name:"邮费管理",
        path: '/admin/platform/postage',
        component: () => import('@/views/market/postage/list.vue'),
      },
      {
        name:"平台反馈",
        path: '/admin/platform/feedback',
        component: () => import('@/views/platform/feedback/list.vue'),
      },
      {
        name:"省份税率",
        path: '/admin/platform/taxrate',
        component: () => import('@/views/platform/taxrate/list.vue'),
      }
    ]
  },
  
  // 平台-客服管理
  {
    path: '/admin/customer',
    component:Layout,
    redirect:'/admin/customer/list',
    children:[
      {
        name:"客服列表",
        path: '/admin/customer/list',
        component: () => import('@/views/platform/customer/list.vue'),
      }
    ]
  },

  // 平台-用户系统
  {
    path: '/admin/user',
    component:Layout,
    redirect:'/admin/user/list',
    children:[
      {
        name:"用户系统",
        path: '/admin/user/list',
        component: () => import('@/views/platform/user/list.vue'),
      },
      {
        name:"平台用户",
        path: '/admin/user/moobylist',
        component: () => import('@/views/platform/user/moobylist.vue'),
      },
      {
        name:"夜市用户",
        path: '/admin/user/nightlist',
        component: () => import('@/views/platform/user/nightlist.vue'),
      },
      {
        name:"其他用户",
        path: '/admin/user/otherlist',
        component: () => import('@/views/platform/user/otherlist.vue'),
      },
      {
        name:"夜市数据跟踪",
        path: '/admin/user/night',
        component: () => import('@/views/platform/user/night.vue'),
      },
    ]
  },

   // 订货-规格管理
   {
    path: '/buy/spec',
    component:Layout,
    redirect:'/buy/spec/zh',
    children:[
      {
        name:"规格列表",
        path: '/buy/spec/zh',
        component: () => import('@/views/buy/spec/list_zh.vue'),
      },
    ]
  },

  // 订货-自营订货
  {
    path: '/buy/mooby',
    component:Layout,
    redirect:'/buy/mooby/add',
    children:[
      {
        name:"自营单品采购",
        path: '/buy/mooby/add',
        component: () => import('@/views/buy/mooby/add.vue'),
      },
      {
        name:"自营采购筛选",
        path: '/buy/mooby/check',
        component: () => import('@/views/buy/mooby/check.vue'),
      },
      {
        name:"自营采购下单",
        path: '/buy/mooby/order',
        component: () => import('@/views/buy/mooby/order.vue'),
      },
      {
        name:"自营进货单审核",
        path: '/buy/mooby/buylist',
        component: () => import('@/views/buy/mooby/buylist.vue'),
      },
      {
        name:"自营查看进货单",
        path: '/buy/mooby/sumlist',
        component: () => import('@/views/buy/mooby/sumlist.vue'),
      },
    ]
  },

  // 订货-供应商订货
  {
    path: '/buy/supplier',
    component:Layout,
    redirect:'/buy/supplier/upload',
    children:[
      {
        name:"单品采购",
        path: '/buy/supplier/upload',
        component: () => import('@/views/buy/supplier/upload.vue'),
      },
      {
        name:"采购筛选",
        path: '/buy/supplier/check',
        component: () => import('@/views/buy/supplier/check.vue'),
      },
      {
        name:"采购下单",
        path: '/buy/supplier/order',
        component: () => import('@/views/buy/supplier/order.vue'),
      },
      {
        name:"进货单审核",
        path: '/buy/supplier/buylist',
        component: () => import('@/views/buy/supplier/buylist.vue'),
      },
      {
        name:"查看进货单",
        path: '/buy/supplier/sumlist',
        component: () => import('@/views/buy/supplier/sumlist.vue'),
      },
    ]
  },

  // 仓库-清关入库
  {
    path: '/warehouse/enter',
    component:Layout,
    redirect:'/warehouse/enter/customscheck',
    children:[
      {
        name:"海关盘点",
        path: '/warehouse/enter/customscheck',
        component: () => import('@/views/warehouse/enter/customscheck.vue'),
      },
      {
        name:"海关盘点列表",
        path: '/warehouse/enter/customslist',
        component: () => import('@/views/warehouse/enter/customslist.vue'),
      },
      {
        name:"加拿大盘点",
        path: '/warehouse/enter/canadacheck',
        component: () => import('@/views/warehouse/enter/canadacheck.vue'),
      },
      {
        name:"加拿大盘点列表",
        path: '/warehouse/enter/canadalist',
        component: () => import('@/views/warehouse/enter/canadalist.vue'),
      },
      {
        name:"异常报告",
        path: '/warehouse/enter/unusual',
        component: () => import('@/views/warehouse/enter/unusual.vue'),
      },
    ]
  },

  // 仓库-订单出库
  {
    path: '/warehouse/out',
    component:Layout,
    redirect:'/warehouse/out/goodsout',
    children:[
      {
        name:"订单商品出库",
        path: '/warehouse/out/goodsout',
        component: () => import('@/views/warehouse/out/goodsout.vue'),
      },
      {
        name:"订单商品打包",
        path: '/warehouse/out/goodspack',
        component: () => import('@/views/warehouse/out/goodspack.vue'),
      },
      {
        name:"订单商品打包详情",
        path: '/warehouse/out/packdetail/:id',
        component: () => import('@/views/warehouse/out/goodspackdetail.vue'),
      },
      {
        name:"订单商品发货",
        path: '/warehouse/out/goodspost',
        component: () => import('@/views/warehouse/out/goodspost.vue'),
      },
      {
        name:"出库订单列表",
        path: '/warehouse/out/orderlist',
        component: () => import('@/views/warehouse/out/orderlist.vue'),
      },
      {
        name:"异常出库订单列表",
        path: '/warehouse/out/ordererror',
        component: () => import('@/views/warehouse/out/ordererror.vue'),
      },
    ]
  },

  // 仓库-返货入库
  {
    path: '/warehouse/return',
    component:Layout,
    redirect:'/warehouse/return/usual',
    children:[
      {
        name:"返货商品入库",
        path: '/warehouse/return/usual',
        component: () => import('@/views/warehouse/return/usual.vue'),
      },
      {
        name:"返残商品入库",
        path: '/warehouse/return/unusual',
        component: () => import('@/views/warehouse/return/unusual.vue'),
      },
      {
        name:"返货入库列表",
        path: '/warehouse/return/list',
        component: () => import('@/views/warehouse/return/list.vue'),
      },
    ]
  },

  // 仓库-商品库存
  {
    path: '/warehouse/stock',
    component:Layout,
    redirect:'/warehouse/stock/list',
    children:[
      {
        name:"商品库存列表",
        path: '/warehouse/stock/list',
        component: () => import('@/views/warehouse/stock/list.vue'),
      },{
        name:"商品库存轨迹",
        path: '/warehouse/stock/track',
        component: () => import('@/views/warehouse/stock/track.vue'),
      },
    ]
  },

  // 商品-分类管理
  {
    path: '/goods/classify',
    component:Layout,
    redirect:'/goods/classify/first',
    children:[
      {
        name:"一级分类",
        path: '/goods/classify/first',
        component: () => import('@/views/goods/classify/first.vue'),
      },
      {
        name:"二级分类",
        path: '/goods/classify/second',
        component: () => import('@/views/goods/classify/second.vue'),
      },
      // {
      //   name:"三级分类",
      //   path: '/goods/classify/third',
      //   component: () => import('@/views/goods/classify/third.vue'),
      // },
    ]
  },

  // 商品-品牌管理
  {
    path: '/goods/brand',
    component:Layout,
    redirect:'/goods/brand/list',
    children:[
      {
        name:"品牌列表",
        path: '/goods/brand/list',
        component: () => import('@/views/goods/brand/list.vue'),
      },

    ]
  },

  // 商品-关键词添加
  {
    path: '/goods/words',
    component:Layout,
    redirect:'/goods/words/index',
    children:[
      {
        name:"关键词添加",
        path: '/goods/words/index',
        component: () => import('@/views/goods/words/index.vue'),
      },
    ]
  },

  // 商品-自营商品
  {
    path: '/goods/mooby',
    component:Layout,
    redirect:'/goods/mooby/list',
    children:[
      {
        name:"商品列表",
        path: '/goods/mooby/list',
        component: () => import('@/views/goods/mooby/list.vue'),
      },
      {
        name:"添加商品",
        path: '/goods/mooby/add',
        component: () => import('@/views/goods/mooby/add.vue'),
      },
      {
        name:"修改商品",
        path: '/goods/mooby/edit/:id',
        component: () => import('@/views/goods/mooby/edit.vue'),
      },
      {
        name:"待上架商品列表",
        path: '/goods/mooby/beforesale',
        component: () => import('@/views/goods/mooby/beforesale.vue'),
      },
      {
        name:"上架商品列表",
        path: '/goods/mooby/sale',
        component: () => import('@/views/goods/mooby/sale.vue'),
      },
      {
        name:"为你推荐",
        path: '/goods/mooby/recommend',
        component: () => import('@/views/goods/mooby/recommend.vue'),
      },
      {
        name:"新品首发",
        path: '/goods/mooby/new',
        component: () => import('@/views/goods/mooby/new.vue'),
      },
      {
        name:"热销产品",
        path: '/goods/mooby/popular',
        component: () => import('@/views/goods/mooby/popular.vue'),
      },
      {
        name:"下架商品列表",
        path: '/goods/mooby/disablesale',
        component: () => import('@/views/goods/mooby/disablesale.vue'),
      },
      {
        name:"商品分类修改",
        path: '/goods/mooby/classify',
        component: () => import('@/views/goods/mooby/goods-classify.vue'),
      },
      {
        name:"商品回收站",
        path: '/goods/mooby/recover',
        component: () => import('@/views/goods/mooby/recover.vue'),
      },
      {
        name:"商品操作记录",
        path: '/goods/mooby/record',
        component: () => import('@/views/goods/mooby/record.vue'),
      },
      {
        name:"自动任务列表",
        path: '/goods/mooby/automatic',
        component: () => import('@/views/goods/mooby/automatic.vue'),
      },
    ]
  },



  // 商品-评论管理
  {
    path: '/goods/comment',
    component:Layout,
    redirect:'/goods/comment/check',
    children:[
      {
        name:"待审核评论",
        path: '/goods/comment/check',
        component: () => import('@/views/goods/comment/check.vue'),
      },
      {
        name:"已审核评论",
        path: '/goods/comment/success',
        component: () => import('@/views/goods/comment/success.vue'),
      },
      {
        name:"未通过评论",
        path: '/goods/comment/failed',
        component: () => import('@/views/goods/comment/failed.vue'),
      },
    ]
  },

  // 商品-预售管理
  {
    path: '/goods/presale',
    component:Layout,
    redirect:'/goods/presale/batch',
    children:[
      {
        name:"预售批次管理",
        path: '/goods/presale/batch',
        component: () => import('@/views/goods/presale/batch.vue'),
      },
      {
        name:"预售商品录入",
        path: '/goods/presale/add',
        component: () => import('@/views/goods/presale/add.vue'),
      },
      {
        name:"预售商品待上架",
        path: '/goods/presale/setout',
        component: () => import('@/views/goods/presale/setout.vue'),
      },
      {
        name:"预售商品列表",
        path: '/goods/presale/list',
        component: () => import('@/views/goods/presale/list.vue'),
      },
      {
        name:"预售商品展位",
        path: '/goods/presale/show',
        component: () => import('@/views/goods/presale/show.vue'),
      },
      {
        name:"预售商品修改",
        path: '/goods/presale/edit/:id',
        component: () => import('@/views/goods/presale/edit.vue'),
      }
    ]
  },



  // 订单-实时订单
  {
    path: '/order/realtime',
    component:Layout,
    redirect:'/order/realtime/list',
    children:[
      {
        name:"实时订单",
        path: '/order/realtime/list',
        component: () => import('@/views/order/realtime/list.vue'),
      },
    ]
  },

  // 订单-预售订单
  {
    path: '/order/presale',
    component:Layout,
    redirect:'/order/presale/list',
    children:[
      {
        name:"预售订单",
        path: '/order/presale/list',
        component: () => import('@/views/order/presale/list.vue'),
      },
      {
        name:"已售订单",
        path: '/order/presale/soldlist',
        component: () => import('@/views/order/presale/soldlist.vue'),
      },
    ]
  },

  // 订单-商家订单
  {
    path: '/order/merchant',
    component:Layout,
    redirect:'/order/merchant/list',
    children:[
      {
        name:"商家订单",
        path: '/order/merchant/list',
        component: () => import('@/views/order/merchant/list.vue'),
      },
    ]
  },

  // 订单-未支付订单
  {
    path: '/order/unpaid',
    component:Layout,
    redirect:'/order/unpaid/list',
    children:[
      {
        name:"未支付订单",
        path: '/order/unpaid/list',
        component: () => import('@/views/order/unpaid/list.vue'),
      },
    ]
  },

  // 订单-售后管理
  {
    path: '/order/aftersale',
    component:Layout,
    redirect:'/order/aftersale/list',
    children:[
      {
        name:"售后列表",
        path: '/order/aftersale/list',
        component: () => import('@/views/order/aftersale/list.vue'),
      },
    ]
  },

  // 线下门店下单
  {
    path: '/order/offline',
    component:Layout,
    redirect:'/order/offline/list',
    children:[
      {
        name:"线下门店下单",
        path: '/order/offline/list',
        component: () => import('@/views/order/offline/list.vue'),
      }
    ]
  },

   // 营销-首页金刚区
   {
    path: '/market/kong',
    component:Layout,
    redirect:'/market/kong/zh',
    children:[
      {
        name:"中文首页金刚区",
        path: '/market/kong/zh',
        component: () => import('@/views/market/home/zh.vue'),
      },
      {
        name:"英文首页金刚区",
        path: '/market/kong/en',
        component: () => import('@/views/market/home/en.vue'),
      },
    ]
  },


   // 营销-主题
   {
    path: '/market/theme',
    component:Layout,
    redirect:'/market/theme/setting',
    children:[
      {
        name:"主题设置",
        path: '/market/theme/setting',
        component: () => import('@/views/market/theme/setting.vue'),
      },
      {
        name:"自营专区",
        path: '/market/theme/mooby',
        component: () => import('@/views/market/theme/mooby/mooby.vue'),
      },
      {
        name:"天天福利",
        path: '/market/theme/welfare',
        component: () => import('@/views/market/theme/welfare/index.vue'),
      },
      {
        name:"新品预售",
        path: '/market/theme/presale',
        component: () => import('@/views/market/theme/presale/index.vue'),
      },
      {
        name:"礼物专区",
        path: '/market/theme/gift',
        component: () => import('@/views/market/theme/gift/index.vue'),
      },
      {
        name:"优选好货",
        path: '/market/theme/better',
        component: () => import('@/views/market/theme/better/index.vue'),
      }
    ]
  },
   // 营销-刮刮乐
   {
    path: '/market/scratch',
    component:Layout,
    redirect:'/market/scratch/index',
    children:[
      {
        name:"兑换码管理",
        path: '/market/scratch/index',
        component: () => import('@/views/market/scratch/index.vue'),
      },
      {
        name:"优惠返利管理",
        path: '/market/scratch/rebate',
        component: () => import('@/views/market/scratch/rebate.vue'),
      },
      {
        name:"礼品管理",
        path: '/market/scratch/gift',
        component: () => import('@/views/market/scratch/gift.vue'),
      },
      {
        name:"礼品兑换详情",
        path: '/market/scratch/giftDetail',
        component: () => import('@/views/market/scratch/gift-detail.vue'),
      },
      {
        name:"返利审核",
        path: '/market/scratch/audit',
        component: () => import('@/views/market/scratch/audit.vue'),
      },
    ]
  },
  // 营销活动管理
  {
    path: '/market/active',
    component:Layout,
    redirect:'/market/active/bargain',
    children:[
      {
        name:"平台砍价专区",
        path: '/market/active/bargain',
        component: () => import('@/views/market/theme/bargain/index.vue'),
      },
      {
        name:"砍价商品添加",
        path: '/market/active/bargain/add',
        component: () => import('@/views/market/theme/bargain/add.vue'),
      },
      {
        name:"用户列表",
        path: '/market/active/bargain/user',
        component: () => import('@/views/market/theme/bargain/user.vue'),
      },
      {
        name:"直播砍价专区",
        path: '/market/active/live',
        component: () => import('@/views/market/theme/live/index.vue'),
      },
      {
        name:"直播商品添加",
        path: '/market/active/live/add',
        component: () => import('@/views/market/theme/live/add.vue'),
      },
      {
        name:"直播用户列表",
        path: '/market/active/live/user',
        component: () => import('@/views/market/theme/live/user.vue'),
      },
      {
        name:"商品活动专区",
        path: '/market/active/activity',
        component: () => import('@/views/market/theme/activity/index.vue'),
      },
      {
        name:"活动商品详情",
        path: '/market/active/activity/:id',
        component: () => import('@/views/market/theme/activity/detail.vue'),
      },
      {
        name:"首页主题活动",
        path: '/market/active/homeActive',
        component: () => import('@/views/market/theme/homeActive/index.vue'),
      },
      {
        name:"首页主题活动详情",
        path: '/market/active/homeActive/:id',
        component: () => import('@/views/market/theme/homeActive/detail.vue'),
      },
      {
        name:"首页主题活动详情",
        path: '/market/active/homeActive/:id',
        component: () => import('@/views/market/theme/homeActive/detail.vue'),
      },
      {
        name:"首页落地页活动",
        path: '/market/active/landing',
        component: () => import('@/views/market/theme/landing/index.vue'),
      },
      {
        name:"落地页详情",
        path: '/market/active/landing/:id',
        component: () => import('@/views/market/theme/landing/detail.vue'),
      },
      {
        name:"新年活动用户列表",
        path: '/market/active/newyear',
        component: () => import('@/views/market/theme/newyear/list.vue'),
      },
      {
        name:"夜市砍价用户列表",
        path: '/market/active/bargainList',
        component: () => import('@/views/market/theme/bargain/list.vue'),
      },
    ]
  },

   // 营销-广告位
   {
    path: '/market/adv',
    component:Layout,
    redirect:'/market/adv/zh',
    children:[
      {
        name:"广告位",
        path: '/market/adv/zh',
        component: () => import('@/views/market/adv/zh.vue'),
      },
      {
        name:"广告位修改",
        path: '/market/adv/edit/:id',
        component: () => import('@/views/market/adv/edit.vue'),
      },
    ]
  },
     // 公众号裂变
     {
      path: '/market/wechat',
      component:Layout,
      redirect:'/market/wechat/wechatList',
      children:[
        {
          name:"公众号裂变",
          path: '/market/wechat/wechatList',
          component: () => import('@/views/market/wechat/index.vue'),
        },
        {
          name:"助力裂变",
          path: '/market/wechat/lottery',
          component: () => import('@/views/market/wechat/lottery.vue'),
        },
      ]
    },

  // 营销-优惠券
  {
    path: '/market/coupon',
    component:Layout,
    redirect:'/market/coupon/list',
    children:[
      {
        name:"优惠券列表",
        path: '/market/coupon/list',
        component: () => import('@/views/market/coupon/list.vue'),
      },
      {
        name:"优惠券添加",
        path: '/market/coupon/add',
        component: () => import('@/views/market/coupon/add.vue'),
      },
      {
        name:"商家优惠券",
        path: '/market/coupon/merchant',
        component: () => import('@/views/market/coupon/merchant.vue'),
      },
      {
        name:"兑换码列表",
        path: '/market/coupon/codeList',
        component: () => import('@/views/market/coupon/code-list.vue'),
      },
      {
        name:"兑换码添加",
        path: '/market/coupon/codeAdd',
        component: () => import('@/views/market/coupon/code-add.vue'),
      },
    ]
  },

  // 营销-中奖记录
  {
    path: '/market/gift-record',
      component:Layout,
      redirect:'/market/gift-record/list',
      children:[
        {
          name:"中奖记录列表",
          path: '/market/gift-record/list',
          component: () => import('@/views/market/giftRecord/index.vue'),
        },
      ]
  },

  // 消息通知
  {
    path: '/market/message',
    component:Layout,
    redirect:'/market/message/list',
    children:[
      {
        name:"触发消息设置",
        path: '/market/message/list',
        component: () => import('@/views/market/message/list.vue'),
      },
      {
        name:"触发消息列表",
        path: '/market/message/sendList',
        component: () => import('@/views/market/message/send-list.vue'),
      },
      {
        name:"模板消息设置",
        path: '/market/message/mbmsg',
        component: () => import('@/views/market/message/mbmsg.vue'),
      },
    ]
  },

  // 商家-经营类目
  {
    path: '/merchant/category',
    component:Layout,
    redirect:'/merchant/category/list',
    children:[
      {
        name:"经营类目列表",
        path: '/merchant/category/list',
        component: () => import('@/views/merchant/category/list.vue'),
      },
    ]
  },

  // 商家-商家入驻
  {
    path: '/merchant/apply',
    component:Layout,
    redirect:'/merchant/apply/list',
    children:[
      {
        name:"商家入驻申请",
        path: '/merchant/apply/list',
        component: () => import('@/views/merchant/apply/list.vue'),
      },
      {
        name:"商家列表",
        path: '/merchant/apply/success',
        component: () => import('@/views/merchant/apply/success.vue'),
      },
      {
        name:"未通过商家",
        path: '/merchant/apply/error',
        component: () => import('@/views/merchant/apply/error.vue'),
      },
    ]
  },

  // 商家-商家商品
  {
    path: '/merchant/goods',
    component:Layout,
    redirect:'/merchant/goods/beforesale',
    children:[
      {
        name:"待审核商品",
        path: '/merchant/goods/beforesale',
        component: () => import('@/views/merchant/goods/beforesale.vue'),
      },
      {
        name:"已上架商品",
        path: '/merchant/goods/sale',
        component: () => import('@/views/merchant/goods/sale.vue'),
      },
      {
        name:"未通过审核商品",
        path: '/merchant/goods/disablesale',
        component: () => import('@/views/merchant/goods/disablesale.vue'),
      },
      {
        name:"已下架商品",
        path: '/merchant/goods/soldout',
        component: () => import('@/views/merchant/goods/soldOut.vue'),
      },
    ]
  },

  // 商家-合伙人管理
  {
    path: '/merchant/partner',
    component:Layout,
    redirect:'/merchant/partner/list',
    children:[
      {
        name:"合伙人申请",
        path: '/merchant/partner/list',
        component: () => import('@/views/merchant/partner/list.vue'),
      },
      {
        name:"合伙人列表",
        path: '/merchant/partner/success',
        component: () => import('@/views/merchant/partner/success.vue'),
      },
      {
        name:"用户列表",
        path: '/merchant/partner/user',
        component: () => import('@/views/merchant/partner/user.vue'),
      },
      {
        name:"未通过列表",
        path: '/merchant/partner/error',
        component: () => import('@/views/merchant/partner/error.vue'),
      },
      {
        name:"提现管理",
        path: '/merchant/partner/cash-out',
        component: () => import('@/views/merchant/partner/cash-out.vue'),
      },
    ]
  },

  // 统计-点击率
  {
    path: '/summary/CTR',
    component:Layout,
    redirect:'/summary/CTR/module',
    children:[
      {
        name:"模块排行",
        path: '/summary/CTR/module',
        component: () => import('@/views/summary/CTR/module.vue'),
      },
      {
        name:"商品排行",
        path: '/summary/CTR/goods',
        component: () => import('@/views/summary/CTR/goods.vue'),
      },
    ]
  },

  // 统计-商品销售追踪
  {
    path: '/summary/track',
    component:Layout,
    redirect:'/summary/track/module',
    children:[
      {
        name:"商品销售列表",
        path: '/summary/track/module',
        component: () => import('@/views/summary/salestrack/list.vue'),
      },
    ]
  },

  // 统计-搜索排行
  {
    path: '/summary/search',
    component:Layout,
    redirect:'/summary/search/list',
    children:[
      {
        name:"搜索排行",
        path: '/summary/search/list',
        component: () => import('@/views/summary/search/list.vue'),
      },
    ]
  },

  // 统计-商品销售排行
  {
    path: '/summary/sales',
    component:Layout,
    redirect:'/summary/sales/classify',
    children:[
      {
        name:"销售类别排行",
        path: '/summary/sales/classify',
        component: () => import('@/views/summary/sales/classify.vue'),
      },
      {
        name:"销售单品排行",
        path: '/summary/sales/goods',
        component: () => import('@/views/summary/sales/goods.vue'),
      }
    ]
  },

  // 统计-下单统计
  {
    path: '/summary/order',
    component:Layout,
    redirect:'/summary/order/area',
    children:[
      {
        name:"地区统计",
        path: '/summary/order/area',
        component: () => import('@/views/summary/order/area.vue'),
      },
    ]
  },
    
  

  
  // 404 page must be placed at the end !!!
  {
    path: '/404',
    component: Layout404,
    children:[
      {
        path: '/404',
        component: () => import('@/views/404/index.vue'),
        name:"404"
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new VueRouter({
  mode: 'hash', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})



const router = createRouter()

//  路由守卫
router.beforeEach(  (to, from, next) => {

  store.commit('tabAdd', to)
  next()
  
})


export default router


